import React, { ReactNode, PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { Flex, IconTooltip, Text } from 'mdlkit';
import NoMatchFooter from './NoMatchFooter';
import { AffiliationSearchField } from '../../../containers/register';

const FocusShadowIconToolTip = styled(IconTooltip)`
  margin-left: 2px;
  button:focus {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #000000 !important;
    outline: none;
    border-radius: 2px;
  }
`;

const StyledTooltipText = styled(Text)`
  display: flex;
  flex-direction: row;
`;

const StyledLabelText = styled(Text)`
  align-self: start;
`;

const StyledFlex = styled(Flex)`
  align-self: start;
`;

interface Props {
  setHideNav(boolean): void;
  setHideNextPage(boolean): void;
  setShowSkipLink(boolean): void;
}

class AffiliationSearch extends PureComponent<Props> {
  render(): ReactNode {
    const { setHideNextPage, setHideNav, setShowSkipLink } = this.props;
    const id = 'affiliationSearch';

    return (
      <Fragment>
        <StyledLabelText as="label" htmlFor={`${id}-input`} pt="md">
          Search for your insurance provider, employer or benefit group.
        </StyledLabelText>

        <StyledFlex pt="xs" pb="md">
          <StyledTooltipText fontSize={[0, 0, 1]}>
            Tell me more about this&nbsp;
          </StyledTooltipText>

          <FocusShadowIconToolTip ariaLabel="coverage information">
            <Text small>
              You might be eligible for reduced cost visits and other benefits
              offered through your employer, insurance company or benefit group.
              <br />
              <br />
              If you are not sure or don&apos;t have that information handy, you
              can add and modify benefits later.
            </Text>
          </FocusShadowIconToolTip>
        </StyledFlex>

        <AffiliationSearchField
          id={id}
          onNoMatch={setHideNav}
          toggleMemberIdForm={setHideNextPage}
          noMatchError={<NoMatchFooter />}
          placeholder="Example: Blue Cross Blue Shield, Cigna, Walgreens"
          setShowSkipLink={setShowSkipLink}
        />
      </Fragment>
    );
  }
}

export default AffiliationSearch;
